import React from 'react';
import { useIsMediaLibrary } from 'hooks/use-is-media-library';
import { cn } from 'lib/utils';

interface FileManagerLayoutProps {
  children: React.ReactNode;
  headerToolbar: React.ReactNode;
  modals: React.ReactNode;
}

export const FileManagerLayout: React.FC<FileManagerLayoutProps> = ({
  children,
  headerToolbar,
  modals,
}) => {
  const isMediaLibrary = useIsMediaLibrary();

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden">
      <div className="shrink-0">{headerToolbar}</div>

      <div className="flex min-h-0 flex-1 justify-center overflow-hidden px-4 sm:px-6">
        <div
          className={cn(
            'flex min-h-0 w-full flex-1 flex-col overflow-hidden',
            isMediaLibrary ? 'max-w-[1060px]' : 'max-w-[829px]'
          )}
        >
          {children}
        </div>
      </div>

      {modals}
    </div>
  );
};
